<template>
    <div id="giftList" class="row">
        <div class="col-12 col-sm-6 col-lg-4" v-for="gift in gifts" :key="gift.id">
            <ponroy-gift-card
                    repository="site.repository.fidelity_gift"
                    :gift-id="gift.id"
                    :gift-points="gift.points"
                    :gift-title="gift.title"
                    :gift-subtitle="gift.subtitle"
                    :gift-image="gift.image.path"
                    :gift-description="gift.description"
                    :connected="connected"
            >
            </ponroy-gift-card>
        </div>
    </div>
</template>

<script>

    import {mapActions, mapState} from 'vuex';
    import store from '../store';

    export default {
        name: 'ponroy-gift-group',
        store,
        props: {
            connected: {
                type: Boolean,
                required: true,
            },
        },
        computed: {
            ...mapState('gift', {
                gifts(state) {
                    return state.gifts;
                }
            })
        },
    }
</script>



// WEBPACK FOOTER //
// src/SiteBundle/Resources/assets/components/GiftGroup.vue